import { useEffect, useState, useRef } from 'react';
import {
    FormGroup, FormControlLabel, Checkbox, Typography, FormControl, MenuItem, InputLabel, Select
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { toast, Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 100 },
    { id: 'HkWrkStnName', label: 'Work Station', minWidth: 150 },
    { id: 'HkWrkAreaName', label: 'Work Area', minWidth: 150 },
    { id: 'Abrv', label: 'Abbreviation', minWidth: 100 },
];

const SubStationAlloc = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(false);
    const [wrkStn, setWrkStn] = useState([]);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState([]);
    const [formData, setFormData] = useState({
        YojanaName: '',
        HkWrkStnId: '',
        Abrv: '',
        Remark: '',
        Property: '',
        Shift: '',
    });

    const [error, setError] = useState({
        YojanaName: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentStn, setCurrentStn] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedHkWrkStnId, setLastInsertedHkWrkStnId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedStn, setSelectedStn] = useState([]);
    const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
    const [originalRows, setOriginalRows] = useState([]);
    const [deleteConfirmDialog, setDeleteConfirmDialog] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [allocatedItems, setAllocatedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const yojanaNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.HkWrkStnId) {
            const propIdFromState = location.state.PropId || formData.Property;

            setFormData(prev => ({
                ...prev,
                Property: propIdFromState || prev.Property
            }));

            setCurrentStn(location.state.HkWrkStnId);
            fetchSubStation(location.state.HkWrkStnId);
            setMode('view');
            setIsFormDisabled(true);
        } else {
            setMode('add');
            setIsFormDisabled(false);
            setSelectedWorkAreas([]);
            setRows([]);
            setOriginalRows([]);
        }
    }, [location.state]);

    const fetchSubStation = async (id) => {
        try {
            const response = await axiosInstance.post(`MstHkWrkArea/RetriveMstHkWrkStnWiseArea`, {
                HkWrkStnId: parseInt(id),
                Flag: "",
                PropId: parseInt(formData.Property) || 2
            });

            if (response.data.Status === 0 && response.data.Data && Array.isArray(response.data.Data) && response.data.Data.length > 0) {
                const retrievedData = response.data.Data.map((item, index) => ({
                    RowNum: index + 1,
                    HkWrkAreaId: item.HkWrkAreaId,
                    HkWrkAreaName: item.HkWrkAreaName || 'N/A',
                    HkWrkStnName: item.HkWrkStnName || 'N/A',
                    Abrv: item.Abrv || 'N/A',
                    Name: item.Name || `${item.HkWrkStnName} - ${item.HkWrkAreaName}`,
                    IsAllocated: item.Id > 0,
                    Id: item.Id,
                }));

                // Set state with the full data (including those with Id = 0)
                setRows(retrievedData);
                setOriginalRows(retrievedData);
                setDataForPrint(retrievedData);

                const originallyAllocated = retrievedData
                    .filter(item => item.Id > 0)
                    .map(item => item.HkWrkAreaId);

                setAllocatedItems(originallyAllocated);
                setSelectedWorkAreas(originallyAllocated);

                // Mark checkboxes as checked only for valid (non-zero) Ids
                const allocatedIds = retrievedData.filter(item => item.Id !== 0).map(item => item.HkWrkAreaId);
                setSelectedWorkAreas(allocatedIds);

                if (retrievedData[0]) {
                    const firstItem = retrievedData[0];
                    if (!formData.HkWrkStnId) {
                        setFormData(prev => ({
                            ...prev,
                            HkWrkStnId: firstItem.HkWrkStnId
                        }));
                    }
                    setCurrentStn(firstItem.HkWrkStnId);
                }

                setIsPreviousDisabled(false);
                setIsNextDisabled(false);

            } else {
                toast.info(response.data.Message || 'No sub-stations allocated for this work station');
                setRows([]);
                setOriginalRows([]);
                setSelectedWorkAreas([]);
                setFormData(prev => ({ ...prev, HkWrkStnId: id }));
                setCurrentStn(parseInt(id));
            }
        } catch (error) {
            toast.error('Error while fetching sub-station allocation: ' + (error.message || 'Network error'));
            setRows([]);
            setOriginalRows([]);
            setSelectedWorkAreas([]);
        }
    };

    const deleteAllocation = async (hkWrkStnId, hkWrkAreaId) => {
        try {
            const response = await axiosInstance.post(`MstHkWrkArea/DeleteMstHkWrkStnWiseArea`, {
                PropId: parseInt(formData.Property),
                HkWrkStnId: parseInt(hkWrkStnId),
                HkWrkAreaId: parseInt(hkWrkAreaId),
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success('Record deleted successfully.');
                return true;
            } else {
                toast.info(response.data.Message || 'Failed to delete record.');
                return false;
            }
        } catch (error) {
            toast.error('Error while deleting sub station.');
            return false;
        }
    };

    const handlePrevious = async () => {
        if (currentStn && currentStn > 1 && !isPreviousDisabled) {
            await fetchSubStation(currentStn, "P");
        }
    };

    const handleNext = async () => {
        if (currentStn) {
            await fetchSubStation(currentStn, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleCheckboxChange = (row, isChecked) => {
        if (isChecked) {
            setSelectedWorkAreas(prev => [...prev, row.HkWrkAreaId]);
        } else {
            if (row.IsAllocated && row.Id > 0) {
                setItemToDelete({
                    row,
                    hkWrkStnId: formData.HkWrkStnId,
                    hkWrkAreaId: row.HkWrkAreaId
                });
                setDeleteConfirmDialog(true);
            } else {
                setSelectedWorkAreas(prev => prev.filter(id => id !== row.HkWrkAreaId));
            }
        }
    };

    const handleRetrieve = async () => {
        if (!formData.Property) {
            toast.error('Property is required');
            return;
        }
        if (!formData.HkWrkStnId) {
            toast.error('Work Station is required');
            return;
        }

        try {
            const payload = {
                PropId: parseInt(formData.Property),
                HkWrkStnId: parseInt(formData.HkWrkStnId),
                Flag: ""
            };

            const response = await axiosInstance.post('MstHkWrkArea/RetriveMstHkWrkStnWiseArea', payload);

            if (response.data.Status === 0 && response.data.Data && Array.isArray(response.data.Data) && response.data.Data.length > 0) {
                const retrievedData = response.data.Data.map((item, index) => ({
                    RowNum: index + 1,
                    HkWrkAreaId: item.HkWrkAreaId,
                    HkWrkAreaName: item.HkWrkAreaName || 'N/A',
                    HkWrkStnName: item.HkWrkStnName || 'N/A',
                    Abrv: item.Abrv || 'N/A',
                    Name: item.Name || `${item.HkWrkStnName} - ${item.HkWrkAreaName}`,
                    IsAllocated: item.Id > 0,
                    Id: item.Id || 0,
                }));

                setRows(retrievedData);
                setOriginalRows(retrievedData);
                setDataForPrint(retrievedData);

                // Pre-check all actually allocated items
                const allocatedIds = retrievedData
                    .filter(item => item.Id > 0)
                    .map(item => item.HkWrkAreaId);

                setSelectedWorkAreas(allocatedIds);
                setAllocatedItems(allocatedIds);
            } else {
                setRows([]);
                setOriginalRows([]);
                setSelectedWorkAreas([]);
                setAllocatedItems([]);
            }
        } catch (error) {
            toast.error('Error retrieving sub-station data');
            setRows([]);
            setOriginalRows([]);
            setSelectedWorkAreas([]);
            setAllocatedItems([]);
        }
    };

    const handleSubmit = async () => {
        if (!formData.Property) {
            toast.error('Please select a Property');
            return;
        }
        if (!formData.HkWrkStnId) {
            toast.error('Please select a Work Station');
            return;
        }
        if (selectedWorkAreas.length === 0) {
            toast.warning('Please select at least one Sub-Station to allocate');
            return;
        }

        try {
            const payload = selectedWorkAreas.map(HkWrkAreaId => ({
                PropId: parseInt(formData.Property),
                HkWrkStnId: parseInt(formData.HkWrkStnId),
                HkWrkAreaId: HkWrkAreaId,
                DBFLAG: ""
            }));

            const response = await axiosInstance.post('MstHkWrkArea/ManageMstHkWrkStnWiseArea', payload);

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Sub-stations allocated successfully!');
                setMode('view');
                setIsFormDisabled(true);
                await handleRetrieve();
            } else {
                toast.error(response.data.Message || 'Failed to save allocations');
            }
        } catch (error) {
            toast.error('Error saving sub-station allocation');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentStn, "MstHkWrkArea", "HkWrkStnId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentStn(null);
        setStatus("1");
        setSelectedWorkAreas([]);
        setSelectedStn([]);

        const resetRows = originalRows.map(row => ({
            ...row,
            IsAllocated: false
        }));
        setRows(resetRows);

        setTimeout(() => {
            yojanaNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            if (mode === 'edit' && currentStn) {
                await fetchSubStation(currentStn, "R");
                await UnLock(currentStn, "MstHkWrkArea", "HkWrkStnId");
            } else if (mode === 'add') {
                if (lastInsertedHkWrkStnId) {
                    await fetchSubStation(lastInsertedHkWrkStnId, "R");
                    setCurrentStn(lastInsertedHkWrkStnId);
                } else {
                    setIsFormDisabled(true);

                    setSelectedWorkAreas([]);
                    setSelectedStn([]);
                    const resetRows = originalRows.map(row => ({
                        ...row,
                        IsAllocated: false
                    }));
                    setRows(resetRows);
                }
            }
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    useEffect(() => {
        if (currentStn && wrkStn.length > 0 && formData.HkWrkStnId !== currentStn) {
            const exists = wrkStn.some(item => item.id === parseInt(currentStn));
            if (exists) {
                setFormData(prev => ({ ...prev, HkWrkStnId: currentStn }));
            }
        }
    }, [currentStn, wrkStn]);

    useEffect(() => {
        if (formData.HkWrkStnId && formData.Property && !isFormDisabled) {
            handleRetrieve();
        } else if (formData.HkWrkStnId && formData.Property && isFormDisabled) {
            // In view mode, also load data when workstation changes (e.g., via navigation)
            handleRetrieve();
        }
    }, [formData.HkWrkStnId, formData.Property]);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0 && response.data.Data) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);

                    if (location.state?.PropId) {
                        setFormData(prev => ({ ...prev, Property: location.state.PropId }));
                    } else if (dropdownItems.length > 0 && !formData.Property) {
                        setFormData(prev => ({ ...prev, Property: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId, location.state?.PropId]);

    useEffect(() => {
        const fetchWorkStation = async () => {
            if (!formData.Property) {
                setWrkStn([]);
                return;
            }

            try {
                const response = await axiosInstance.post('MstHkWrkStn/getMstHkWrkStndrp', {
                    PropId: parseInt(formData.Property)
                });

                if (response?.data?.Status === 0 && response.data.Data) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.Id,
                        name: item.Name,
                    }));
                    setWrkStn(dropdownItems);

                    const targetId = location.state?.HkWrkStnId || currentStn;
                    if (targetId) {
                        const matched = dropdownItems.find(stn => stn.id === parseInt(targetId));
                        if (matched) {
                            setFormData(prev => ({ ...prev, HkWrkStnId: matched.id }));
                        }
                    }
                }
            } catch (error) {
                toast.error("Error fetching work station data");
                setWrkStn([]);
            }
        };

        fetchWorkStation();
    }, [formData.Property, currentStn, location.state?.HkWrkStnId]);

    const handleExit = () => {
        navigate('/substntable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmSingleDelete = async () => {
        if (!itemToDelete) return;

        const { hkWrkStnId, hkWrkAreaId } = itemToDelete;

        const success = await deleteAllocation(hkWrkStnId, hkWrkAreaId);

        if (success) {
            setSelectedWorkAreas(prev => prev.filter(id => id !== hkWrkAreaId));
            setAllocatedItems(prev => prev.filter(id => id !== hkWrkAreaId));

            setRows(prevRows => prevRows.map(r =>
                r.HkWrkAreaId === hkWrkAreaId
                    ? { ...r, IsAllocated: false, Id: 0 }
                    : r
            ));
            setOriginalRows(prevRows => prevRows.map(r =>
                r.HkWrkAreaId === hkWrkAreaId
                    ? { ...r, IsAllocated: false, Id: 0 }
                    : r
            ));
        }

        setDeleteConfirmDialog(false);
        setItemToDelete(null);
    };

    const handleCancelSingleDelete = () => {
        if (itemToDelete) {
            setSelectedWorkAreas(prev => {
                if (!prev.includes(itemToDelete.hkWrkAreaId)) {
                    return [...prev, itemToDelete.hkWrkAreaId];
                }
                return prev;
            });
        }
        setDeleteConfirmDialog(false);
        setItemToDelete(null);
    };

    const handleConfirmDelete = async () => {
        if (!formData.HkWrkStnId && !currentStn) {
            toast.info("No work station selected.");
            setOpenConfirmDialog(false);
            return;
        }

        if (allocatedItems.length === 0) {
            toast.info("No allocated sub-stations to delete.");
            setOpenConfirmDialog(false);
            return;
        }

        const flag = await checkAndLock(currentStn || formData.HkWrkStnId, "MstHkWrkArea", "HkWrkStnId");
        if (flag !== 0) {
            toast.error(flag === 1 ? "Record Already Locked" : "Record Failed To Lock");
            setOpenConfirmDialog(false);
            return;
        }

        try {
            const response = await axiosInstance.post(`MstHkWrkArea/DeleteMstHkWrkStnWiseArea`, {
                PropId: parseInt(formData.Property),
                HkWrkStnId: parseInt(formData.HkWrkStnId || currentStn),
                HkWrkAreaId: 1,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success('All sub-station allocations deleted.');

                setSelectedWorkAreas([]);
                setAllocatedItems([]);
                setRows(prev => prev.map(r => ({ ...r, IsAllocated: false, Id: 0 })));
                setOriginalRows(prev => prev.map(r => ({ ...r, IsAllocated: false, Id: 0 })));
            } else {
                toast.error(response.data.Message || 'Failed to delete allocations.');
                await handleRetrieve();
            }
        } catch (error) {
            toast.error('Error deleting allocations: ' + (error.message || 'Network error'));
            await handleRetrieve();
        } finally {
            await UnLock(currentStn || formData.HkWrkStnId, "MstHkWrkArea", "HkWrkStnId");
            setMode('view');
            setIsFormDisabled(true);
            setOpenConfirmDialog(false);
        }
    };

    const filteredRows = rows.filter(row =>
        searchQuery === '' ||
        (row.HkWrkAreaName && row.HkWrkAreaName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.HkWrkStnName && row.HkWrkStnName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.Abrv && row.Abrv.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    useEffect(() => {
        if (filteredRows.length === 0) {
            return;
        }
        const allVisibleSelected = filteredRows.every(row => selectedWorkAreas.includes(row.HkWrkAreaId));
    }, [selectedWorkAreas, searchQuery]);

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "90vh" },
                overflowX: "hidden",
                overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
            }}>
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '22px', sm: '18px', md: '24px' },
                            }}
                        >
                            Substation Allocation To Station
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Sub Station Allocation"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={2} justifyContent="start">
                            <Grid item xs={12} md={4}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="property-label">Property</InputLabel>
                                    <Select
                                        labelId="property-label"
                                        id="Property"
                                        name="Property"
                                        value={formData.Property}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                    >
                                        {dropdownData.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="HkWrkStnId-label">Work Station</InputLabel>
                                    <Select
                                        labelId="HkWrkStnId-label"
                                        id="HkWrkStnId"
                                        name="HkWrkStnId"
                                        value={formData.HkWrkStnId}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 250,
                                                    overflowY: 'auto',
                                                },
                                            },
                                        }}
                                    >
                                        {wrkStn.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 1
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mr: 2 }}>
                                                SubStation:
                                            </Typography>

                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            disabled={isFormDisabled}
                                                            checked={
                                                                filteredRows.length > 0 &&
                                                                filteredRows.every(row => selectedWorkAreas.includes(row.HkWrkAreaId))
                                                            }
                                                            indeterminate={
                                                                filteredRows.length > 0 &&
                                                                filteredRows.some(row => selectedWorkAreas.includes(row.HkWrkAreaId)) &&
                                                                !filteredRows.every(row => selectedWorkAreas.includes(row.HkWrkAreaId))
                                                            }
                                                            onChange={(e) => {
                                                                const wantToSelectAll = e.target.checked;

                                                                if (wantToSelectAll) {
                                                                    const toAdd = filteredRows
                                                                        .filter(row => !selectedWorkAreas.includes(row.HkWrkAreaId))
                                                                        .map(row => row.HkWrkAreaId);

                                                                    setSelectedWorkAreas(prev => [...new Set([...prev, ...toAdd])]);
                                                                } else {
                                                                    const visibleIds = new Set(filteredRows.map(row => row.HkWrkAreaId));
                                                                    setSelectedWorkAreas(prev => prev.filter(id => !visibleIds.has(id)));
                                                                }
                                                            }}
                                                            color="success"
                                                        />
                                                    }
                                                    label="Select All"
                                                />
                                            </FormGroup>
                                        </Box>

                                        <TextField
                                            id="search-workarea"
                                            placeholder="Search Work Area or Station..."
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                width: '200px',
                                                '& .MuiOutlinedInput-root': {
                                                    height: '32px',
                                                    borderRadius: '20px'
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '4px 15px',
                                                    fontSize: '0.875rem',
                                                },
                                                marginLeft: 'auto'
                                            }}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            disabled={isFormDisabled}
                                            InputProps={{
                                                endAdornment: searchQuery && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setSearchQuery('')}
                                                        sx={{ mr: -1, p: 0.5 }}
                                                        disabled={isFormDisabled}
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: {
                                            xs: 'repeat(1, 1fr)',
                                            sm: 'repeat(2, 1fr)',
                                            md: 'repeat(3, 1fr)',
                                            lg: 'repeat(6, 1fr)',
                                        },
                                        maxHeight: '300px',
                                        overflowY: 'auto',
                                        padding: '8px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: '#f9f9f9',
                                        gap: '2px',
                                    }}>
                                        {filteredRows.map((row) => (
                                            <FormControlLabel
                                                key={row.HkWrkAreaId}
                                                control={
                                                    <Checkbox
                                                        color="success"
                                                        size="small"
                                                        checked={selectedWorkAreas.includes(row.HkWrkAreaId)}
                                                        onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                                                        disabled={isFormDisabled}
                                                        sx={{
                                                            margin: 0,
                                                            padding: 0,
                                                            transform: 'scale(0.8)',
                                                            '&.Mui-checked': {
                                                                color: '#2e7d32',
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontSize: '0.875rem',
                                                            color: selectedWorkAreas.includes(row.HkWrkAreaId)
                                                                ? '#2e7d32'
                                                                : row.IsAllocated
                                                                    ? '#ff9800'
                                                                    : 'inherit',
                                                            fontWeight: selectedWorkAreas.includes(row.HkWrkAreaId) ? 'bold' : 'normal',
                                                            margin: 0,
                                                            padding: 0,
                                                            marginLeft: '4px',
                                                        }}
                                                    >
                                                        {row.HkWrkAreaName}
                                                        {/* {row.Abrv && row.Abrv !== 'N/A' && ` (${row.Abrv})`} */}
                                                        {selectedWorkAreas.includes(row.HkWrkAreaId) && ' ✓'}
                                                    </Typography>
                                                }
                                                sx={{
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                            />
                                        ))}
                                    </Box>

                                    {selectedWorkAreas.length > 0 && (
                                        <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
                                            Selected: {selectedWorkAreas.length} work area
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled={isFormDisabled}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled={isFormDisabled}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Sub Station Allocation"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </Box>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        size='small'
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        size='small'
                        sx={{
                            backgroundColor: '#c71313ff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#c01515ff', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmDialog}
                onClose={handleCancelSingleDelete}
                aria-labelledby="delete-single-dialog-title"
            >
                <DialogTitle id="delete-single-dialog-title">
                    Delete Sub-Station?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete Sub-Station "<strong>{itemToDelete?.row?.HkWrkAreaName}</strong>" from this work station?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmSingleDelete} variant='contained' size='small' color="error">
                        Delete
                    </Button>
                    <Button onClick={handleCancelSingleDelete} variant='contained' size='small' autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SubStationAlloc;